import { Globals } from "../CoreApp/Globals";
import { EventToCanvas } from "./EventToCanvas";
import { prepHandleEvent } from "./prepHandleEvent";

export function handleTouchStart(event) {
  // in android, we send multi touch events to our gesture event functions for pinch zoom
  if (event.touches.length == 2) {
    var dist = Math.hypot(
      event.touches[0].pageX - event.touches[1].pageX,
      event.touches[0].pageY - event.touches[1].pageY
    );
    Globals._lastMultiTouchDim = dist;
    event.preventDefault();
    event.stopPropagation();
  } else if (event.touches.length == 1 && !Globals._gestureActive) {
    var theTouch = event.targetTouches[0];
    var x = theTouch.clientX;
    var y = theTouch.clientY;
    var canvas = document.getElementById("basecanvas");
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas({ clientX: x, clientY: y }, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;
    myApp.HandleMouseDown(p.x, p.y);
    event.preventDefault();
    event.stopPropagation();
  }
}
